import { render, staticRenderFns } from "./SurveyThumbnail.vue?vue&type=template&id=5481d02c"
import script from "./SurveyThumbnail.ts?vue&type=script&lang=ts&external"
export * from "./SurveyThumbnail.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports